// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__wE8W5","list":"styles_list__6BDCQ"};